import { render, staticRenderFns } from "./xianggui.vue?vue&type=template&id=06bc4445&scoped=true&"
import script from "./xianggui.vue?vue&type=script&lang=js&"
export * from "./xianggui.vue?vue&type=script&lang=js&"
import style0 from "./xianggui.vue?vue&type=style&index=0&id=06bc4445&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bc4445",
  null
  
)

export default component.exports